import { Injectable } from '@angular/core';
import { SERVER_URL, environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  reportData: any;

  constructor(
    private http: HttpClient, private storageService: StorageService
  ) { }

  async getDashBoards(){

    const url = environment.url + '/osiris/settings/dashboard/?customer=' + this.storageService.getSelectedMall().id
    const httpOptions = this.storageService.getAuthHeaders();

    return await this.http.get(url, httpOptions).toPromise().then((data: any) => {
      return data.results;
    });

  }
}
